import React from "react"
import { Link } from "gatsby"
import styled from "styled-components"

import Layout from "../components/layout"
import Image from "../components/image"
import SEO from "../components/seo"

import "../fonts/fonts.css"
import Quiz from "../components/mobile/quiz"

import logo from "../images/vip-logo.png"
import hello from "../images/hello.png"
import banner from "../images/banner.png"

const IndexPage = () => (
  <SiteContainer>
    <MobileContainer>
      <Layout>
        <SEO title="Home" />
        <Header>
          <img src={banner} width="100%"></img>
        </Header>
        <Quiz></Quiz>
      </Layout>
    </MobileContainer>
  </SiteContainer>
)

export default IndexPage

export const MobileContainer = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #c23616;
  overflow-y: scroll;

  @media (max-width: 480px) {
    width: 100vw;
  }
`

export const BackgroundContainer = styled.div`
  width: 32vw;
  height: 100vh;
  background-color: black;
`

export const SiteContainer = styled.div`
  display: flex;
  flex-direction: row;
  font-family: 'Montserrat', 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`

export const HeaderText = styled.div`
  font-size: 32px;
  font-family: "Gotham Book";
`

export const Header = styled.div`
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`